import { useSyncExternalStore } from 'react';
import { t } from '../../i18n';
import {
  canGoFullscreen,
  canInstall,
  install,
  isFullscreen,
  needsHomeScreen,
  onFullscreenChange,
  onInstallChange,
  toggleFullscreen,
} from '../../app/fullscreen';

const subscribe = (listener: () => void) => {
  const a = onInstallChange(listener);
  const b = onFullscreenChange(listener);
  return () => {
    a();
    b();
  };
};
const snapshot = () =>
  `${canInstall() ? 'i' : ''}${canGoFullscreen() ? 'f' : ''}${isFullscreen() ? 'F' : ''}`;

/**
 * Ways to play full screen, on the title screen: install the app where the browser offers it,
 * go full screen where it can, and on an iPhone, how to add the game to the Home Screen.
 */
export function FullScreenOffer() {
  const state = useSyncExternalStore(subscribe, snapshot, () => '');
  const installable = state.includes('i');
  const fullscreen = state.includes('f');
  const homeScreen = !installable && !fullscreen && needsHomeScreen();
  if (!installable && !fullscreen && !homeScreen) return null;
  return (
    <div className="fullscreen-offer">
      {installable && (
        <button type="button" className="btn btn-small" onClick={() => void install()}>
          {t('app.install')}
        </button>
      )}
      {fullscreen && (
        <button
          type="button"
          className="btn btn-small"
          aria-pressed={state.includes('F')}
          onClick={() => void toggleFullscreen()}
        >
          {state.includes('F') ? t('app.leaveFullscreen') : t('app.fullscreen')}
        </button>
      )}
      {homeScreen && <p className="field-hint">{t('app.homeScreenHint')}</p>}
    </div>
  );
}
